import withGetService from './with-post-service';

export default withGetService;
